import { IEdicionForm, IModelFormulario } from '../../model/candidato-api'
export class Formulario {
  idform: number
  data: IModelFormulario

  esNuevo = false

  constructor(f: IEdicionForm, esNuevo = false) {
    this.data = f.data
    this.idform = f.data.idform

    this.esNuevo = esNuevo
  }

  actualiza(data: IEdicionForm) {}
}
